'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bar = require('./styled/bar');

var _bar2 = _interopRequireDefault(_bar);

var _step = require('./styled/step');

var _step2 = _interopRequireDefault(_step);

var _stepNumber = require('./styled/step-number');

var _stepNumber2 = _interopRequireDefault(_stepNumber);

var _stepTitle = require('./styled/step-title');

var _stepTitle2 = _interopRequireDefault(_stepTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// styled
function WizardProgress(_ref) {
  var pages = _ref.pages,
      currentPage = _ref.currentPage;

  return _react2.default.createElement(
    _bar2.default,
    null,
    pages.map(function (page, i) {
      return _react2.default.createElement(
        _step2.default,
        {
          key: page['#webform_key'],
          step: i,
          style: { width: 100 / pages.length + '%' },
          active: i === currentPage,
          done: i < currentPage
        },
        _react2.default.createElement(
          _stepNumber2.default,
          null,
          i + 1
        ),
        _react2.default.createElement(
          _stepTitle2.default,
          null,
          page['#title']
        )
      );
    })
  );
}

WizardProgress.propTypes = {
  pages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    '#title': _propTypes2.default.string.isRequired,
    '#webform_key': _propTypes2.default.string.isRequired
  })).isRequired,
  currentPage: _propTypes2.default.number.isRequired
};

exports.default = WizardProgress;